window.jQuery = jQuery;
window.$      = $;

require('./libs/jquery.fitvids');
require('./libs/jquery.waitforimages');
require('./libs/pretty-embed');

function getVideoId(url) {
  const urlStart  = url.search(/=/i);

  if (urlStart < 0) {
    const splitUrl  = url.split('/');
    const id        = splitUrl[splitUrl.length - 1];

    return id;
  } else {
    return url.substr(urlStart + 1, url.length);
  }
}

export function fullSectionVideo($section) {
  const url       = $section.text();

  $section.prettyEmbed({
    videoID: getVideoId(url),
    previewSize: 'hd',				// use either this option...
    // customPreviewImage: '',			// ...or this option
    // Embed controls
    showInfo: false,
    showControls: true,
    loop: false,
    colorScheme: 'dark',
    showRelated: false,
    useFitVids: true
  });

  $section.on('click', function() {
    if (!$section.hasClass('play')) {
      $section.prettyEmbed({
        videoID: getVideoId(url),
        previewSize: 'hd',
        showInfo: false,
        showControls: true,
        loop: false,
        colorScheme: 'dark',
        showRelated: false,
        useFitVids: true
      });
    }
  });
}



// WEBPACK FOOTER //
// ./js/video.js